import React from "react";
import { Box, Typography } from "@mui/material";

/** Single labelled figure used across the admin statistics panels. */
export default function StatsSummaryTile({ label, value, hint }) {
    return (
        <Box sx={{ p: 1.25, border: 1, borderColor: "divider", borderRadius: 1 }}>
            <Typography variant="caption" color="text.secondary" display="block">
                {label}
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {value}
            </Typography>
            {hint ? (
                <Typography variant="caption" color="text.secondary">
                    {hint}
                </Typography>
            ) : null}
        </Box>
    );
}
